<template>
  <v-container fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" md="4" justify="center" align="center">
        <base-material-card
          :height="height"
          id="pie"
          color="primary"
          icon="mdi-heart-flash"
          :title="$t('dashboard.machineHealthIndex')"
          class="px-4 py-3 "
        >
          <vue-gauge class="h-100 my-auto"></vue-gauge>
        </base-material-card>
      </v-col>
      <v-col
        cols="12"
        md="4"
        :class="$vuetify.breakpoint.mdAndUp ? '' : 'my-12'"
        justify="center"
        align="center"
      >
        <base-material-card
          :height="height"
          id="pie"
          color="primary"
          icon="mdi-chart-bar"
          :title="$t('dashboard.mechanincalCondition')"
          class="px-4 py-3"
          ><v-container class="h-70 d-flex justify-center align-center"
            ><bar-graphics></bar-graphics></v-container
        ></base-material-card>
      </v-col>

      <v-col cols="12" md="4" justify="center" align="center">
        <base-material-card
          :height="height"
          id="pie"
          color="primary"
          icon="mdi-chart-pie"
          :title="$t('dashboard.reliabilitySummary')"
          class="px-4 py-3"
        >
          <template v-if="list && list.list">
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  :label="$t('dashboard.datepicker.title')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker range v-model="date">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false">{{
                  $t("dashboard.datepicker.cancelbtn")
                }}</v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(date)">{{
                  $t("dashboard.datepicker.okbtn")
                }}</v-btn>
              </v-date-picker>
            </v-dialog>
            <div>
              <apexchart
                type="radialBar"
                height="350"
                :series="reliablityResume"
                :options="pie"
              />
            </div>
          </template>
          <div v-else class="optional">
            <v-card class="pa-10" color="secondary" dark>
              No reliability information yet
            </v-card>
          </div>
        </base-material-card>
      </v-col>
      <v-col cols="12" justify="center" align="center"
        ><keep-alive
          ><mechanical-condition-chart></mechanical-condition-chart
        ></keep-alive>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import BarGraphics from "./BarGraphics";
import reliabilityCalcMixin from "@/mixins/reliabilityCalcMixin";
import { StatusTypes } from "@/utils/status";

export default {
  mixins: [reliabilityCalcMixin],
  components: {
    "vue-gauge": () => import("./VueGauge"),
    "base-material-card": () => import("@/components/MaterialCard.vue"),
    "mechanical-condition-chart": () => import("./MechanicalConditionChart"),
    BarGraphics
  },
  data() {
    return {
      colouredLine: {
        data: {
          labels: [
            "'06",
            "'07",
            "'08",
            "'09",
            "'10",
            "'11",
            "'12",
            "'13",
            "'14",
            "'15"
          ],
          series: [[275, 500, 290, 55, 700, 700, 500, 750, 630, 900, 930]]
        },
        options: {
          low: 0,
          high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      dailySalesChart: {
        data: {
          labels: ["M", "T", "W", "T", "F", "S", "S"],
          series: [[12, 17, 7, 17, 23, 18, 38]]
        },
        options: {
          low: 0,
          high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
          showPoint: false
        }
      },
      dataCompletedTasksChart: {
        data: {
          labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
          series: [[230, 750, 450, 300, 280, 240, 200, 190]]
        },
        options: {
          low: 0,
          high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      emailsSubscriptionChart: {
        data: {
          labels: [
            "Ja",
            "Fe",
            "Ma",
            "Ap",
            "Mai",
            "Ju",
            "Jul",
            "Au",
            "Se",
            "Oc",
            "No",
            "De"
          ],
          series: [[542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]]
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.none(),
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      },
      multipleBar: {
        data: {
          labels: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ],
          series: [
            [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
            [400, 200, 250, 575, 450, 300, 285, 370, 370, 410, 620, 690]
          ]
        },
        options: {
          seriesBarDistance: 10,
          lineSmooth: this.$chartist.Interpolation.none(),
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 900,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          }
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function(value) {
                  return value[0];
                }
              }
            }
          ]
        ]
      },
      multipleLine: {
        data: {
          labels: [
            "'06",
            "'07",
            "'08",
            "'09",
            "'10",
            "'11",
            "'12",
            "'13",
            "'14",
            "'15"
          ],
          series: [
            [275, 500, 290, 55, 700, 700, 500, 750, 630, 900, 930],
            [575, 600, 490, 75, 300, 400, 700, 450, 130, 200, 330],
            [575, 300, 890, 155, 640, 540, 800, 250, 230, 400, 630]
          ]
        },
        options: {
          low: 0,
          high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      /* pie: {
        data: {
          series: [62, 32, 6]
        },
        options: {
          labelInterpolationFnc: value => `${value}%`
        }
      } */
      pie: {
        series: [76, 67, 61, 90],
        chart: {
          height: 450,
          type: "radialBar"
        },
        plotOptions: {
          radialBar: {
            offsetY: 0,
            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 5,
              size: "25%",
              background: "transparent",
              image: undefined
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                show: false
              }
            }
          }
        },
        colors: ["#008450", "#EFB700", "#DA530A", "#B81D13"],
        labels: [
          this.$t("dashboard.statuslights.running"),
          this.$t("dashboard.statuslights.standby"),
          this.$t("dashboard.statuslights.maintenance"),
          this.$t("dashboard.statuslights.failure")
        ],
        tooltip: {
          enabled: true
        },
        legend: {
          show: true,
          floating: true,
          fontSize: "14px",
          position: "left",
          offsetX: -35,
          horizontalAlign: "left",
          offsetY: 10,
          fontWeight: 500,
          width: 200,
          labels: {
            useSeriesColors: true
          },
          markers: { width: 10, height: 10 },
          formatter: function(seriesName, opts) {
            return (
              seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "%"
            );
          },
          itemMargin: {
            vertical: 2.5
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                height: 300
              },
              legend: {
                show: true,
                fontSize: "10px",
                position: "left",
                offsetY: 5,
                offsetX: -35,
                horizontalAlign: "left",
                itemMargin: {
                  vertical: 0.8
                }
              }
            }
          },
          {
            breakpoint: 800,
            options: {
              chart: {
                height: 500
              },
              legend: {
                show: true,
                fontSize: "24px",
                position: "left",
                offsetY: 25,
                width: 300,
                offsetX: 25,
                horizontalAlign: "left",
                itemMargin: {
                  vertical: 4
                }
              }
            }
          }
        ]
      },
      date: [],
      modal: false
    };
  },
  methods: {
    complete(index) {
      this.list[index] = !this.list[index];
    }
  },
  computed: {
    height() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "auto";
        case "sm":
          return "auto";
        case "md":
          return 500;
        case "lg":
          return 500;
        case "xl":
          return 600;
        default:
          return 600;
      }
    },
    reliablityResume() {
      if (this.totalTime) {
        if (this.date.length < 2) {
          const resume = [
            ((this.running.totalTime / this.totalTime) * 100).toFixed(2),
            ((this.standBy.totalTime / this.totalTime) * 100).toFixed(2),
            ((this.maintenance.totalTime / this.totalTime) * 100).toFixed(2),
            ((this.failure.totalTime / this.totalTime) * 100).toFixed(2)
          ];
          return resume;
        } else {
          const resumeRecalc = [
            this.list
              .recalculatePercentage(StatusTypes.uptime, this.date)
              .toFixed(2),
            this.list
              .recalculatePercentage(StatusTypes.standBy, this.date)
              .toFixed(2),
            this.list
              .recalculatePercentage(StatusTypes.maintenance, this.date)
              .toFixed(2),
            this.list
              .recalculatePercentage(StatusTypes.failure, this.date)
              .toFixed(2)
          ];
          return resumeRecalc;
        }
      } else {
        return ["10", "20", "50", "20"];
      }
    },
    ...mapState("equipments", ["equipmentProfile"]),

    totalTime() {
      return (
        this.running?.totalTime +
        this.standBy?.totalTime +
        this.maintenance?.totalTime +
        this.failure?.totalTime
      );
    }
  }
};
</script>

<style lang="sass">
.apexcharts-legend-series
  text-align: left

#coloured-line
  .ct-series-a .ct-line,
  .ct-series-a .ct-point
    stroke: #00cae3 !important

#multiple-bar
  .ct-series-a .ct-bar
    stroke: #00cae3 !important

  .ct-series-b .ct-bar
    stroke: #f44336 !important

#pie
  .ct-series-a .ct-slice-pie
    fill: #008450 !important
  .ct-series-b .ct-slice-pie
    fill: #EFB700 !important
  .ct-series-c .ct-slice-pie
    fill: #DA530A !important
  .ct-series-d .ct-slice-pie
    fill: #B81D13 !important
  .ct-chart-pie .ct-label
    fill: white !important
    color: white !important

.optional
  display: flex
  align-items: center
  justify-content: center
  height: 70%
  .v-card
    width: 100%

.h-100
  height: 100%

.h-70
  height: 70%
</style>
